<template>
    <section>
        <b-collapse
            class="collapse-wrapper-anchor"
            :open="false" 
            position="is-bottom" 
            aria-id="contentIdForA11y4">
            <template #trigger="props" >
                <a
                    aria-controls="contentIdForA11y4"
                    :aria-expanded="props.open">
                    <b-icon :icon="!props.open ? 'menu-down' : 'menu-up'"></b-icon>
                    {{ !props.open ? 'Mostrar filtros' : 'Ocultar Filtros' }}
                </a>
            </template>
            <div class="wrapper-collapse"> 
              <div class="title-filter"> Filtrar resultados </div>
              <div class="fields-content-wrapper">
                <div class="field-wrapper">
                  <label class="label-form">Producto</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.productsSelected"
                    :options="products"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper">
                  <label class="label-form">Estado</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.metaStatesSelected"
                    :options="metaStates"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="metastate_name"
                    track-by="metastate_name"
                    :preselect-first="false"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper">
                  <label class="label-form">Broker</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.brokersSelected"
                    :options="brokers"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="name"
                    track-by="name"
                    :preselect-first="false"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper" v-if="executiveNationalSupervisor">
                  <label class="label-form">Supervisor</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    @input="handleSupervisorSelect"
                    @remove="handleRemoveOption"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.supervisorsSelected"
                    :options="executiveSupervisors"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="full_name"
                    track-by="full_name"
                    :preselect-first="false"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper" v-if="executiveNationalSupervisor">
                  <label class="label-form">Ejecutivo</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.operativesSelected"
                    :options="operativesNational"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="full_name"
                    track-by="full_name"
                    :disabled="excutiveFilterIsDisabled"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper" v-if="executiveTeamSupervisor">
                  <label class="label-form">Ejecutivo</label>
                  <multiselect
                    class="select-multiple"
                    selectedLabel="SELECCIONADO"
                    deselectLabel="REMOVER"
                    selectLabel="SELECCIONAR"
                    v-model="selectedFilters.operativesSelected"
                    :options="executiveOperatives"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Busca una o más opciones"
                    label="full_name"
                    track-by="full_name"
                  >
                    <span slot="noResult">No se encontraron resultados</span>
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} opciones seleccionadas</span></template>
                  </multiselect>
                </div>
                <div class="field-wrapper">
                  <label class="label-form">Fecha de creación</label>
                  <b-field>
                      <b-datepicker
                          icon-right="calendar-today"
                          class="date-field"
                          placeholder="Desde - Hasta"
                          v-model="selectedFilters.datesCreation"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :month-names="monthNames"
                          @input="changeDate"
                          range>
                      </b-datepicker>
                  </b-field>
                </div>
                <div class="field-wrapper">
                  <label class="label-form">Fecha de modificación</label>
                  <b-field>
                      <b-datepicker
                          icon-right="calendar-today"
                          class="date-field"
                          placeholder="Desde - Hasta"
                          v-model="selectedFilters.datesUpdates"
                          :month-names="monthNames"
                          :min-date="minDate"
                          :max-date="maxDate"
                          range>
                      </b-datepicker>
                  </b-field>
                </div>
              </div>
              <div class="buttons-wrapper">
                <a class="button-wrapper" @click="deleteFilters">Borrar filtros</a>
                <button class="button-primary__lineal" @click="handleFilter" > Filtrar </button>
              </div>
            </div>
        </b-collapse>
    </section>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { isExecutiveTeamSupervisor, isExecutiveNationalSupervisor } from '../mixins/user'
import  quoteRepository  from '../services/QuoteRepository'
import { getExecutiveList } from '@/services/User/executive';
import store from "@/store";

const dataQueryFilters = {
      }

export default {
  name: "FilterDashboard",
  components: {
    Multiselect
  },
  props: {
    products: Array,
    selectedFilters: Object
  },
  data () {
    const today = new Date()
    return {
      value: [],
      dates: [],
      estadoValue: [],
      executives: [],
      teamOptions: [],
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      excutiveFilterIsDisabled: true,
      operativesNational: [],
      monthNames: ["Enero","Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]
    }
  },
  computed: {
    brokers() {
      return store.state.brokerFilter
    },
    executiveSupervisors() {
      return store.state.teamList.filter( (executive) =>  executive.profile_level === "EXECUTIVE_TEAM_SUPERVISOR" )
    },
    executiveOperatives() {
      return store.state.teamList.filter( (executive) =>  executive.profile_level === "EXECUTIVE_OPERATIVE" )
    },
    metaStates() {
      return store.state.metaStatesFilter
    },
    executiveTeamSupervisor() {
      return isExecutiveTeamSupervisor()
    },
    executiveNationalSupervisor() {
      return isExecutiveNationalSupervisor()
    }
  },
  mounted() {
    
  },
  methods: {
    changeDate(dates) {
    },
    deleteFilters() {
      this.excutiveFilterIsDisabled = true
      this.$emit("cleanFilters")
    },
    handleSupervisorSelect(selectedOptions) {
      this.excutiveFilterIsDisabled = false
      const idsSelected = []
      let idsQuerysParameters = ""
      if (selectedOptions) {
        selectedOptions.map((selectedOption) => idsSelected.push(selectedOption.id) )
      }
      if (idsSelected) {
        idsSelected.map( id => {
          idsQuerysParameters = idsQuerysParameters.concat(`${id},`)
        })
      }
      if (idsQuerysParameters) {
        getExecutiveList(`team/?superior__in=${idsQuerysParameters}`).then((result) => {
          this.operativesNational = result.data;
          this.excutiveFilterIsDisabled = false
        })
      } else {
        this.operativesNational = []
        this.excutiveFilterIsDisabled = true
      }
    },
    handleRemoveOption(removeOption) {
      const newOperatives = this.selectedFilters.operativesSelected.filter( operativeSelected => operativeSelected.superior_id != removeOption.id)
      this.selectedFilters.operativesSelected = newOperatives

    },

    encodeQuery(data){
      let query = ""
      for (let d in data)
        query += encodeURIComponent(d) + '=' + encodeURIComponent(data[d]) + '&'
      return query.slice(0, -1)
      },

    encodeValuesQueryParameters(filterSelected) {
      let valueQueryString = ""
      this.selectedFilters[filterSelected].map(productSelected => {
        valueQueryString = valueQueryString.concat(`${productSelected.id},`)
      })
      const finalQueryString = valueQueryString.substring(0, valueQueryString.length-1)
      switch (filterSelected) {
        case 'productsSelected':
          dataQueryFilters['product__in'] = finalQueryString;
          break;
        case 'brokersSelected':
          dataQueryFilters['broker_business__in'] = finalQueryString;
          break;
        case 'operativesSelected':
          dataQueryFilters['executive_op__in'] = finalQueryString;
          break;
        case 'supervisorsSelected':
          dataQueryFilters['executive_tsup__in'] = finalQueryString;
          break;
        case 'metaStatesSelected':
          dataQueryFilters['metastate__in'] = finalQueryString;
          break;
        default:
          console.log('aqui cierra');
      }

    },

    async handleFilter() {
      const loader = this.$buefy.loading.open();
      let datecreationBeforeISO = ""
      let dateCreationAfterISO = ""
      let dateUpdatesBeforeISO = ""
      let dateUpdatesAfterISO = ""
      if ( this.selectedFilters.datesCreation.length != 0) {
        this.selectedFilters.datesCreation[1].setHours(18)
        this.selectedFilters.datesCreation[1].toLocaleString()
        datecreationBeforeISO = this.selectedFilters.datesCreation[1].toISOString()
        this.selectedFilters.datesCreation[0].setHours(-5)
        this.selectedFilters.datesCreation[0].toLocaleString()
        dateCreationAfterISO =this.selectedFilters.datesCreation[0].toISOString()
      }
      if ( this.selectedFilters.datesUpdates.length != 0) {
        this.selectedFilters.datesUpdates[1].setHours(18)
        this.selectedFilters.datesUpdates[1].toLocaleString()
        dateUpdatesBeforeISO = this.selectedFilters.datesUpdates[1].toISOString()
        this.selectedFilters.datesUpdates[0].setHours(-5)
        this.selectedFilters.datesUpdates[0].toLocaleString()
        dateUpdatesAfterISO = this.selectedFilters.datesUpdates[0].toISOString()
      }
      for (let filterSelected in this.selectedFilters) {
        if (filterSelected !== "datesUpdates" && filterSelected !== "datesCreation" ) {
          this.encodeValuesQueryParameters(filterSelected)
        } else {
          switch (filterSelected) {
            case 'datesUpdates':
              dataQueryFilters['updated_before'] = dateUpdatesBeforeISO;
              dataQueryFilters['updated_after'] = dateUpdatesAfterISO;
              break;
            case 'datesCreation':
              dataQueryFilters['created_before'] = datecreationBeforeISO;
              dataQueryFilters['created_after'] = dateCreationAfterISO;
            default:
              console.log('aqui cierra');
          }
        }
      }
      const queryParameters = this.encodeQuery(dataQueryFilters)
      const dataToDispatch = {
        page: 1,
        querys: `&${queryParameters}`
      }
      await store.dispatch('getListPage', dataToDispatch)
      store.commit('setQueryFilters', `&${queryParameters}`)
      loader.close()
      if (store.state.dataTable.length == 0) {
        store.commit('setThereFilterResults', false )
      } else {
        store.commit('setThereFilterResults', true )
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" >
  .content {
      margin-bottom: 0 !important;
  }
  .wrapper-collapse {
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 12px;
  }
  .collapse-wrapper-anchor {
      .collapse-trigger {
        display: flex;
        justify-content: center;
      }
  }
  .date-field {
    margin-top: 8px;
    div {
      .dropdown-trigger {
        div {
          input {
            border: 1px solid #e8e8e8;
            border-radius: 5px;
            padding: 10px;
            box-shadow: none !important;
            height: 40px;
          }
          span {
            bottom: 0;
            top: none;
          }
        }
      }
    }
  }
  .label-form {
    color: #6A7178;
    margin-bottom: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
  }
  .title-filter {
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin: 12px;
  }
  .field-wrapper {
    margin: 12px;
  }
  .fields-content-wrapper {
    display: grid;
    grid-template-columns: 33% 33% 33%;
  }
  .buttons-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  .button-wrapper {
    margin-right: 17px;
    margin-left: 17px;
    display: flex;
    align-items: center;
    text-decoration-line: underline;
    color: #FF6D46;
  }
  .select-multiple {
    margin-top: 8px;
    .multiselect__select {
      height: 100%;
    }
  }
</style>